/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./total-footer.vue?vue&type=template&id=7ee6dc10&scoped=true&"
import script from "./total-footer.vue?vue&type=script&lang=ts&"
export * from "./total-footer.vue?vue&type=script&lang=ts&"
import style0 from "./total-footer.vue?vue&type=style&index=0&id=7ee6dc10&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ee6dc10",
  null
  
)

export default component.exports